<template>
    <div v-if="showApp">
        <page-web-logs></page-web-logs>
    </div>
</template>

<script>

import PageWebLogs from "@/projects/web-logs/components/page-home.vue";

export default {
    data() {
        return {
            showApp: false,
        };
    },
    mounted() {
        let appsToShow = this.$store.state.webApplicationToShow;
        let currentApp = this.$route.fullPath.replace("/", "").split('?')[0];
        if (appsToShow.includes(currentApp)) this.showApp = true;
    },
    components: {
        PageWebLogs,
    },
};
</script>

<style></style>
